import { DOE_CONFIG } from './configs/doe.config';
import { Environment } from './environment.types';

export const environment: Environment = {
  production: true,
  variant: DOE_CONFIG.variant,
  mocked: false,
  ...DOE_CONFIG.test,
};
